export default class Prompter {
	constructor(options) {
		this.onPrompt = function (_message, _os) { };

		if (!options) options = {};
		this.appName = options.appName || 'The Game';
		this.message1 = options.promptMessage1 || 'Having fun?';
		this.message2 = options.promptMessage2 || 'It looks like you really like %@?';
		this.message3 = options.promptMessage3 || 'Are you addicted to %@?';
		this.message4 = options.promptMessage4 || 'You have played a zillion times. Do you like %@ yet?';
		this.message5 = options.promptMessage5 || 'You have played 300 zillion times. Do you like %@ yet?';


		//localStorage key needs to be set before load
		this.localStorageKey = (this.appName.toLowerCase().replace(/\s/g, '') || "") + '.delayedPromptCount';

		this.openCount = options.openCount || this.load();
	}

	StorageAvailable(type) {
		try {
			const storage = window[type],
				x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return false;
		}
	}

	load() {
		let openCount = 0;

		if (this.StorageAvailable('localStorage')) {
			openCount = localStorage.getItem(this.localStorageKey) || 0;
			openCount = Number(openCount) || 0;
		}

		return openCount;
	}

	save(openCount) {
		if (this.StorageAvailable('localStorage')) {
			localStorage[this.localStorageKey] = openCount;
		}
	}

	delayedPrompt(openCount) {
		if (!openCount) {
			openCount = (this.openCount + 1) || 1;
		}
		let message = null;

		if (openCount == 10) {
			message = 'Having fun?';
		}

		if (openCount == 25) {
			message = 'It looks like you really like %@?';
		}

		if (openCount == 50) {
			message = 'Are you addicted to %@?';
		}

		if (openCount == 100) {
			message = 'You have played a zillion times. Do you like %@ yet?';
		}
		if (openCount == 200) {
			message = 'You have played 200 zillion times. Do you like %@ yet?';
		}
		if (openCount == 300) {
			message = 'You have played 300 zillion times. Do you like %@ yet?';
		}
		if (openCount == 400) {
			openCount = 0;
		}



		this.openCount = openCount;
		this.save(this.openCount);

		if (message) {
			message = message.replace('%@', this.appName);

			if (this.onPrompt) {
				const os = this.getOS();
				this.onPrompt(message, os);
			}
		}
	}

	getOS() {
		const ua = navigator.userAgent;
		const isCordova = typeof cordova != 'undefined';

		//var url = window && window.location && window.location.href && window.location.href || "";
		if (typeof FBInstant !== 'undefined') {
			return 'FBMessenger';
		}

		if (/(Windows Phone.*MSAppHost\/3.0)/i.test(navigator.appVersion)) {
			// Windows 10 UWP
			return 'windowsPhone';
		}

		if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
			// Windows 10 UWP
			return 'windows';
		}

		const isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

		if (isCordova && /(android)/i.test(navigator.userAgent) && isKindle) {
			return 'amazon';
		}

		if (isCordova && /(android)/i.test(navigator.userAgent) && !isKindle) {
			return 'android';
		}

		if (isCordova && (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel')) {
			return 'ios';
		}

		return 'web';
	}
}
